import {Action} from '@ngrx/store';
import {VeranstaltungMinimal} from '../../../../clients/qschecks';
import {QsFilter} from '../qschecks-controlling-saison-filter/qschecks-controlling-saison-filter.model';

export const PAGE_STATE_RESET = '[QSChecksControllingHomePage] Page State reset';

export const SAISON_UEBERSICHT_LADEN = '[QSChecksControllingHomePage] Saison-Übersicht laden';
export const SAISON_UEBERSICHT_NEU_LADEN = '[QSChecksControllingHomePage] Saison-Übersicht neu laden';
export const AKTUELLE_VERANSTALTUNG_QS_CONTROLLING_SETZEN = '[QSChecksControllingHomePage] Aktuelle Veranstaltung setzen';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

export class SaisonUebersichtLadenAction implements Action {
    readonly type = SAISON_UEBERSICHT_LADEN;

    constructor(public payload: QsFilter) {
    }
}

export class SaisonUebersichtNeuLadenAction implements Action {
    readonly type = SAISON_UEBERSICHT_NEU_LADEN;

    constructor() {
    }
}

export class AktuelleVeranstaltungQsControllingSetzenAction implements Action {
    readonly type = AKTUELLE_VERANSTALTUNG_QS_CONTROLLING_SETZEN;

    constructor(public payload: VeranstaltungMinimal) {
    }
}


/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    PageStateResetAction
    | SaisonUebersichtLadenAction
    | SaisonUebersichtNeuLadenAction
    | AktuelleVeranstaltungQsControllingSetzenAction
    ;
